export function useSessionStorage() {
    const isAvailable = typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';

    const setItem = (key: string, value: string) => {
        if (!isAvailable) {
            return false;
        }

        try {
            window.sessionStorage.setItem(key, value);

            return true;
        } catch {
            return false;
        }
    };

    const getItem = (key: string) => {
        if (!isAvailable) {
            return null;
        }

        try {
            return window.sessionStorage.getItem(key);
        } catch {
            return null;
        }
    };

    const removeItem = (key: string) => {
        if (!isAvailable) {
            return false;
        }

        try {
            window.sessionStorage.removeItem(key);

            return true;
        } catch {
            return false;
        }
    };

    return {
        getItem,
        removeItem,
        setItem,
    };
}
